// extracted by mini-css-extract-plugin
export default {"text-area":"TextArea_text-area__4NUms"};